// Translation: Account > Billing > Methods > Payment method removal dialog (German)
export default Object.freeze({
	actions: {
		cancel: '',
		remove: ''
	},
	message: {
		text: '',
		title: ''
	}
})
